/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import {
  Box,
  Flex,
  Drawer,
  DrawerBody,
  useColorModeValue,
  useDisclosure,
  DrawerContent,
  Avatar,
  Text,
  DrawerOverlay,
  Button,
  Image,
} from "@chakra-ui/react";
import CustomerContent from "components/sidebar/components/CustomerContent";
import {
  renderThumb,
  renderTrack,
  renderView,
} from "components/scrollbar/Scrollbar";
import { Scrollbars } from "react-custom-scrollbars-2";
import { IconCloseHamburgur, IconHamburgur } from "components/icons/Icons";
import IconBox from "components/icons/IconBox";
import { useDispatch, useSelector } from "react-redux";
import { userSelector } from "store/user/selector";
import { logoutRequest } from "store/user/reducer";
import { useNavigate } from "react-router-dom";
import logo from "assets/img/layout/logo.svg";
import logoutIcon from "assets/img/layout/logout.svg";

function CustomerSidebar(props: { routes: RoutesType[]; [x: string]: any }) {
  const { routes } = props;

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onLogOut = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("user_details");
    dispatch(logoutRequest());
    navigate("/auth/sign-in/");
  };

  const openProfileDetails = () => {
    navigate("/customer/account-details");
  };

  return (
    <Box
      display={{ sm: "none", xl: "block" }}
      position="fixed"
      minH="100%"
      zIndex="100"
    >
      <Box
        bg={"#F4F6FB"}
        transition={"0.2s linear"}
        w="296px"
        h="100vh"
        m="0px"
        minH="100%"
        overflowX="hidden"
        padding={"40px 47px 40px 48px"}
        borderRight="1px solid #E6ECF3"
      >
        <Flex direction="column" justifyContent="space-between" h="100%">
          <Box>
            {/* Logo */}
            <Box mb="32px">
              <Image src={logo} alt="Languex" height="32px" width="auto" />
            </Box>

            <Scrollbars
              autoHide
              renderTrackVertical={renderTrack}
              renderThumbVertical={renderThumb}
              renderView={renderView}
            >
              <CustomerContent routes={routes} />
            </Scrollbars>
          </Box>

          <Box mt="24px">
            <Button
              variant="link"
              justifyContent="flex-start"
              w="100%"
              padding="0"
              height="auto"
              fontSize="14px"
              color="#111827"
              onClick={onLogOut}
              leftIcon={<Image src={logoutIcon} alt="" w="20px" h="20px" />}
            >
              Log out
            </Button>
          </Box>
        </Flex>
      </Box>
    </Box>
  );
}

export default CustomerSidebar;
